import Cubes from './Cubes';
import Faces from './Faces';

const PuzzleData = {
  Cubes,
  Faces,
  Tracks: [3, 15, 23, 16],
};

export default PuzzleData;
